// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2e61075e","239":"47ab950f","453":"fde25b73","553":"60bdbc85"}[chunkId] + ".chunk.js";
};